"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _redux = require("redux");
var _resource = _interopRequireDefault(require("./reducers/resource.js"));
var _builder = _interopRequireDefault(require("./reducers/builder.js"));
var _player = _interopRequireDefault(require("./reducers/player.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _redux.combineReducers)({
  resource: _resource["default"],
  builder: _builder["default"],
  player: _player["default"]
});